import { render } from "./AddAgent.vue?vue&type=template&id=3cc74b32&scoped=true"
import script from "./AddAgent.vue?vue&type=script&lang=js"
export * from "./AddAgent.vue?vue&type=script&lang=js"

import "./AddAgent.vue?vue&type=style&index=0&id=3cc74b32&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3cc74b32"

export default script